import type { CompanyEmployeeBinding } from '@/models/api/company-employee-binding'
import {
  companyEmployeeBindingResponseSchema,
  type CompanyEmployeeBindingResponse
} from '@/models/api/company-employee-binding-response'
import {
  apiValidator,
  type ApiFactory,
  type ApiRequestConfig,
  type ApiResponse
} from '~library/services'

export default class CompanyEmployeeBindApi {
  constructor(private api: ApiFactory) {}

  /**
   * API 企業員工綁定
   * https://hackmd.io/OHV-m0yYRuyquNekVRVaSg
   */
  @apiValidator(companyEmployeeBindingResponseSchema)
  binding(
    data: CompanyEmployeeBinding,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<CompanyEmployeeBindingResponse>> {
    return this.api.post('CompanyEmployee/Binding', data, config)
  }
}
